'use strict';

angular.module('cimerFrontEndApp').directive('emailAvailableValidator', ['$http', 'ApiUrl', function ($http, ApiUrl) {
    var _apiUrl = ApiUrl.url('/User/');
    return {
        require: 'ngModel',
        link: function ($scope, element, attrs, ngModel) {
            ngModel.$asyncValidators.emailAvailable = function (email) {
                return $http.get(_apiUrl + 'EmailIsAvailable', { params: { email: email } })
                    .then(function (response) {
                        ngModel.$setValidity('duplicate', response.data);
                        if (!response.data) {
                            return q.reject();
                        }
                        return true;
                    });
            };
        }
    };
}]);